<template>
    <div class="chars-page-header">
        <!-- 搜索框 -->
        <div class="chars-search">
            <!-- 标题 -->
            <div class="title">
                <img src="../../../../assets/circle.png" alt="">
                中华字典查询
            </div>
            <!-- 输入框 -->
            <el-input placeholder="请输入汉字" v-model="searchContent" maxlength="1">
                <el-button slot="append" type="primary" icon="el-icon-search"
                           @click="search"
                           class="clicks"></el-button>
            </el-input>
        </div>


        <!-- 毛玻璃遮罩层 -->
        <div class="pic-blur"></div>
    </div>
</template>

<script>
    import {GetCharByContent} from "@/request/chars";

    export default {
        name: "Header",
        data(){
            return{
                searchContent:""
            }
        },
        methods:{
            /**
             * @author 孟祥龙
             * @Desc TODO 处理搜索
             * @date 2021/5/9 8:53
             * @return
             */
            search(){
                if (this.searchContent !== ""){
                    // 发送请求
                    GetCharByContent({
                        content:this.searchContent
                    }).then(res => {
                        // 查询结果不为空
                        if (res.code === 200 && res.data.list.length !== 0){
                            this.$router.push("/charsDetail/"+res.data.list[0].id);
                        }
                    })
                }
            }
        }
    }
</script>

<style scoped lang="less">
    .chars-page-header{
        height: 350px;
        background-image: url("../../../../assets/font-back.jpg");
        position: relative;
        display: flex;
        align-items: center;
        // 遮罩模糊
        .pic-blur{
            width: 100%;
            height: 100%;
            position: absolute;
            left: 0;
            top:0;
            background-color: rgba(0,0,0,.4);
        }
        /* 搜索框 */
        .chars-search{
            width: 680px;
            margin:  auto;
            position: relative;
            z-index: 10;
            /* 标题 */
            .title{
                color: white;
                font-size: 28px;
                font-weight: bold;
                text-align: center;
                margin-bottom: 15px;
                display: flex;
                align-items: center;
                justify-content: center;
                letter-spacing: 3px;
                user-select: none;
                /* 图片 */
                img{
                    height: 60px;
                    margin-right: 10px;
                }
            }
        }

    }
</style>

<style lang="less">
    .chars-page-header{
        /* 更改按钮样式 */
        .el-input-group__append{
            background-color: #DD4455 !important;
            color: white;
            border: 1px solid #DD4455;
        }
    }

</style>